import React, { useState, useEffect } from 'react';
import './JobSubscriptionButton.css'; // Reuse the same CSS
import { fetchSubscriptions, createSubscription, deleteSubscription } from './api';

const WorkOrderSubscriptionButton = ({ workOrder, onSubscriptionChange }) => {
  const [isSubscribed, setIsSubscribed] = useState(false);
  const [subscriptionId, setSubscriptionId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [checking, setChecking] = useState(true);

  useEffect(() => {
    checkSubscription();
  }, [workOrder.id]);

  const checkSubscription = async () => {
    setChecking(true);
    try {
      const response = await fetchSubscriptions();
      const workOrderSubscription = response.find(
        sub => sub.subscription_type === 'specific_workorder' && sub.work_order_id === workOrder.id
      );
      
      if (workOrderSubscription) {
        setIsSubscribed(true);
        setSubscriptionId(workOrderSubscription.id);
      } else {
        setIsSubscribed(false);
        setSubscriptionId(null);
      }
    } catch (error) {
      console.error('Error checking subscription:', error);
    } finally {
      setChecking(false);
    }
  };

  const toggleSubscription = async () => {
    setLoading(true);
    try {
      if (isSubscribed) {
        // Unsubscribe
        await deleteSubscription(subscriptionId);
        setIsSubscribed(false);
        setSubscriptionId(null);
        if (onSubscriptionChange) {
          onSubscriptionChange(false);
        }
      } else {
        // Subscribe
        const response = await createSubscription({
          subscription_type: 'specific_workorder',
          work_order_id: workOrder.id,
          notify_on_create: true,
          notify_on_update: true,
          notify_on_status_change: true,
        });
        
        setIsSubscribed(true);
        setSubscriptionId(response.id);
        if (onSubscriptionChange) {
          onSubscriptionChange(true);
        }
      }
    } catch (error) {
      console.error('Error toggling subscription:', error);
      alert('Error updating subscription. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  if (checking) {
    return (
      <button className="job-subscription-btn checking" disabled>
        <span className="spinner"></span>
      </button>
    );
  }

  return (
    <button 
      className={`job-subscription-btn ${isSubscribed ? 'subscribed' : 'not-subscribed'}`}
      onClick={toggleSubscription}
      disabled={loading}
      title={isSubscribed ? 'Unsubscribe from notifications' : 'Subscribe to notifications'}
    >
      {loading ? (
        <span className="spinner"></span>
      ) : (
        <>
          {isSubscribed ? '🔔' : '🔕'}
          <span className="btn-text">
            {isSubscribed ? 'Subscribed' : 'Subscribe'}
          </span>
        </>
      )}
    </button>
  );
};

export default WorkOrderSubscriptionButton;

